const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const required = (
  value,
  message = "Please fill in this required field"
) => (!value ? message : undefined);

export const email = (value) =>
  !emailRegex.test(value) ? "Invalid email address" : undefined;
